import React, { Component, Fragment } from "react";
import AuthService from "../../services/auth";

import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

import "./styles.css";
import Input from "../../components/Input";
import Button from "../../components/Button";
import LoadingMask from "../../components/LoadingMask";
import Modal from "../../components/Modal";
import TermsOfUse from "./TermsOfUse";

class Welcome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userData: null,
      isLoading: true,
      termsOfUseIsVisible: false,
    };
  }

  componentDidMount() {
    AuthService.getCurrentUserData().then((response) => {
      const { history } = this.props;

      const userData = response.data.data;

      this.setState({
        userData,
        isLoading: false,
      });

      if (userData.email && userData.displayName) {
        history.push("/players");
      }
    });
  }

  toggleTermsOfUse = () => {
    this.setState({
      termsOfUseIsVisible: !this.state.termsOfUseIsVisible,
    });
  };

  onFormSubmit = (values) => {
    this.setState({ isLoading: true });

    AuthService.updateUserData(
      values.email,
      values.fullName,
      values.authorization,
      values.newsletter
    )
      .then(() => {
        const { history } = this.props;

        this.setState({ isLoading: false });

        history.push(`/players`);
      })
      .catch((e) => {
        this.setState({ isLoading: false });

        toast(e.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          hideProgressBar: true,
        });
      });
  };

  render() {
    const { userData, isLoading, termsOfUseIsVisible } = this.state;

    return (
      <div className="PageContainerSmall">
        <h2 className="RegisterPlayer__title">Completar Cadastro</h2>

        {termsOfUseIsVisible && (
          <Modal
            title="Termos de Uso"
            onClose={this.toggleTermsOfUse}
            onBackdropClick={this.toggleTermsOfUse}
          >
            <TermsOfUse />
          </Modal>
        )}

        {isLoading && <LoadingMask />}
        <div className="RegisterPlayer">
          {userData && (
            <Fragment>
              <p>
                Olá <b>{userData.displayName}</b>, por favor, preencha ou
                confirme as informações abaixo para finalizar o seu cadastro.
              </p>
              <Formik
                validateOnMount={true}
                initialValues={{
                  fullName: userData.displayName || "",
                  email: userData.providerEmail || "",
                  termsOfUse: false,
                }}
                validationSchema={Yup.object({
                  email: Yup.string()
                    .email("Email inválido")
                    .required("E-mail é obrigatório"),
                  fullName: Yup.string().required(
                    "Nome completo é obrigatório"
                  ),
                  termsOfUse: Yup.bool()
                    .oneOf([true], "Obrigatório aceitar os termos de uso")
                    .required("Obrigatório aceitar os termos de uso"),
                })}
                onSubmit={this.onFormSubmit}
              >
                {(formik) => (
                  <form onSubmit={formik.handleSubmit} className="WelcomeForm">
                    <div className="InputGroup">
                      <Input
                        name="fullName"
                        label="Nome completo*"
                        type="text"
                        placeholder="Digite seu nome..."
                        {...formik.getFieldProps("fullName")}
                      />

                      {formik.touched.fullName && formik.errors.fullName ? (
                        <span className="WelcomeForm__error">
                          {formik.errors.fullName}
                        </span>
                      ) : null}
                    </div>

                    <div className="InputGroup">
                      <Input
                        name="email"
                        label="E-mail*"
                        type="email"
                        placeholder="Digite seu e-mail..."
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <span className="WelcomeForm__error">
                          {formik.errors.email}
                          <br />
                          <br />
                        </span>
                      ) : null}

                      <div className="InputGroup InputGroup--checkbox">
                        <input
                          id="termsOfUse"
                          type="checkbox"
                          name="termsOfUse"
                          {...formik.getFieldProps("termsOfUse")}
                        />

                        <label htmlFor="termsOfUse">
                          Concordo com os&nbsp;
                          <a onClick={this.toggleTermsOfUse}>Termos de uso</a>
                        </label>
                        {formik.touched.termsOfUse &&
                        formik.errors.termsOfUse ? (
                          <div className="WelcomeForm__error">
                            {formik.errors.termsOfUse}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <Button
                      type="submit"
                      text="Salvar e prosseguir"
                      disabled={!formik.isValid}
                      block
                    />
                  </form>
                )}
              </Formik>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default Welcome;
